import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
// See app.js for why this second registration under the canonical name is needed.
gsap.core.globals('ScrollTrigger', ScrollTrigger);

const DEFAULT_WORDS = ['Innovate', 'Create', 'Grow', 'Disrupt', 'Transform', 'Scale'];
const CHAR_DELAY = 65;
const ERASE_DELAY = 38;
const HOLD       = 1800;

function getFooterWords(footerEl) {
    const raw = footerEl?.dataset?.footerWords;
    if (!raw) return DEFAULT_WORDS;

    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
            const words = parsed.map((word) => String(word).trim()).filter(Boolean);
            if (words.length) return words;
        }
    } catch {
        // Fall back to defaults when CMS JSON is malformed.
    }

    return DEFAULT_WORDS;
}

function startFooterTypewriter(wordEl, words) {
    let idx = 0;

    function typeIn(text, done) {
        let i = 0;
        wordEl.textContent = '';
        (function step() {
            if (i < text.length) { wordEl.textContent += text[i++]; setTimeout(step, CHAR_DELAY); }
            else done?.();
        })();
    }

    function eraseOut(done) {
        (function step() {
            const t = wordEl.textContent;
            if (t.length > 0) { wordEl.textContent = t.slice(0, -1); setTimeout(step, ERASE_DELAY); }
            else done?.();
        })();
    }

    function cycle() {
        typeIn(words[idx], () => {
            idx = (idx + 1) % words.length;
            setTimeout(() => eraseOut(() => setTimeout(cycle, 180)), HOLD);
        });
    }

    cycle();
}

export function initFooter() {
    const footer = document.querySelector('.site-footer');
    if (!footer) return;

    const words = getFooterWords(footer);
    const blocks = [...footer.querySelectorAll('[data-from]')];

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: footer,
            start: 'top 82%',
            toggleActions: 'play none none reverse',
            onEnter: () => {
                const wordEl = document.getElementById('footer-word');
                if (wordEl && !wordEl.dataset.started) {
                    wordEl.dataset.started = '1';
                    startFooterTypewriter(wordEl, words);
                }
            },
        },
    });

    blocks.forEach((block, i) => {
        const dir = block.dataset.from;
        const fromProps = { opacity: 0, duration: 0.75, ease: 'power2.out' };
        if (dir === 'left')   fromProps.x = -70;
        if (dir === 'right')  fromProps.x = 70;
        if (dir === 'bottom') fromProps.y = 50;
        if (dir === 'top')    fromProps.y = -50;
        tl.from(block, fromProps, i * 0.12);
    });
}
